// extracted by mini-css-extract-plugin
export default {"searchResults":"Search_searchResults__OV4SU","shimmer":"Search_shimmer__40gLJ"};